import { render, staticRenderFns } from "./GlobalForestWatch.vue?vue&type=template&id=7468b4b4&lang=pug"
import script from "./GlobalForestWatch.vue?vue&type=script&lang=js"
export * from "./GlobalForestWatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports